import styled from 'styled-components'
import { useWindowSize } from 'react-use'
import Confetti from 'react-confetti'
import { TypeAnimation } from 'react-type-animation';
import { IoClose } from "react-icons/io5";

import './App.css';
import { Fragment, useEffect, useRef, useState } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import Marquee from "react-fast-marquee";

function App() {

  const { width, height } = useWindowSize();

  const audioRef = useRef();
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const [startSecond, setStartSecond] = useState(false);
  const [startThird, setStartThird] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress >= 100) {
            clearInterval(interval);
            return 100;
          }
          return oldProgress + 10; // Tăng dần mỗi 100ms
        });
      }, 600);
    }
  }, [loading]);

  

  return (
    <Fragment>
    {
      loading ? (
        <LoadingWrapper>
            { progress !== 100 ? (
              <div>
                <LoadingContent>
                  <TypeAnimation
                      key={1}
                      sequence={[
                        // Same substring at the start will only be typed out once, initially
                        'Đang tải',
                        1000, // wait 1s before replacing "Mice" with "Hamsters"
                        'Chờng xíu',
                        1000,
                      ]}
                      wrapper="span"
                      speed={200}
                      style={{ fontSize: '2em', display: 'inline-block' }}
                      repeat={Infinity}
                      deletionSpeed={90}
                  />
                </LoadingContent>
                <ProgressWrapper>
                  {
                    Array.from({ length: progress / 10 }).map((val, index) => {
                      return (
                        <span className='text-[55px]'>🤸🏼</span>
                      )
                    })
                  }
                </ProgressWrapper>
                <LoadingContent>
                  <LoadingText>{progress}%</LoadingText>
              </LoadingContent>
            </div>
            ) : (
              <div>
                <LoadingContent>
                  <TypeAnimation
                      key={2}
                      sequence={[
                        "Let's go",
                        1000,
                        'Click start',
                        1000,
                      ]}
                      wrapper="span"
                      speed={200}
                      style={{ fontSize: '2.5em', display: 'inline-block' }}
                      repeat={Infinity}
                      deletionSpeed={90}
                  />
                </LoadingContent>
                <button 
                  style={{ background: "unset", border: "unset", margin: "auto", display: "block", pointerEvents: "all", cursor: "pointer"}} 
                  onClick={() => {
                    setLoading(false); 
                    audioRef.current.play();
                  }}>
                    <img style={{ width: "240px"}} className='click' src={require("./assets/download.gif")} alt="" />
                </button>
              </div>
            )
          }
      </LoadingWrapper>
    )  : (
      <AppWrapper openModal={openModal}>
        <Container>
          <Marquee speed={50} gradient={false}>
            <RainBowTop>
                <img className='rainbow' src={require("./assets/200w.gif")} alt="" />
                <img className='rainbow' src={require("./assets/1753.gif")} alt="" />
                <img className='rainbow' src={require("./assets/Rainbow.gif")} alt="" />
                <img className='rainbow' src={require("./assets/1753.gif")} alt="" />
                <img className='rainbow' src={require("./assets/200w.gif")} alt="" />
                <img className='rainbow' src={require("./assets/1753.gif")} alt="" />
                <img className='rainbow' src={require("./assets/Rainbow.gif")} alt="" />
                <img className='rainbow' src={require("./assets/200w.gif")} alt="" />
                <img className='rainbow' src={require("./assets/1753.gif")} alt="" />
                <img className='rainbow' src={require("./assets/Rainbow.gif")} alt="" />
            </RainBowTop>
          </Marquee>
          <MainContent>
            <UIAImage>
             <div className='uia'>
                <img src={require("./assets/hero.gif")} alt="" />
                <img src={require("./assets/huh.gif")} alt="" />
             </div>
              <div className='trang'>
                <img src={require("./assets/removebg-preview.png")} alt="" />
              </div>
              <div className='uia'>
                
              <img src={require("./assets/hero.gif")} alt="" />
                <img src={require("./assets/huh.gif")} alt="" />
              </div>
            </UIAImage>
            <BirthDayContent>
              <p>Happy your birthday</p>
              <h3>YURI <span>🎀</span></h3>
              <p>(Yes! Unexpected Relationship Intensifies!)</p>
       
              <ButtonBirthday onClick={() => setOpenModal(true)}>
                  View your letter
              </ButtonBirthday>
            </BirthDayContent>
        </MainContent>
        <Marquee>
          <RainBowBottom>
            <img className='rainbow' src={require("./assets/200w.gif")} alt="" />
            <img className='rainbow' src={require("./assets/1753.gif")} alt="" />
            <img className='rainbow' src={require("./assets/Rainbow.gif")} alt="" />
            <img className='rainbow' src={require("./assets/1753.gif")} alt="" />
            <img className='rainbow' src={require("./assets/200w.gif")} alt="" />
            <img className='rainbow' src={require("./assets/1753.gif")} alt="" />
            <img className='rainbow' src={require("./assets/Rainbow.gif")} alt="" />
            <img className='rainbow' src={require("./assets/200w.gif")} alt="" />
            <img className='rainbow' src={require("./assets/1753.gif")} alt="" />
            <img className='rainbow' src={require("./assets/Rainbow.gif")} alt="" />
          </RainBowBottom>
        </Marquee>
      </Container>
      <ConfettiWrapper>
      <Confetti
          numberOfPieces={90}
          width={width}
          height={height}
          gravity={0.05}
          wind={0}
          drawShape={(ctx) => {
            ctx.beginPath();
            ctx.arc(0, 0, 4, 0, 2 * Math.PI); // Tạo confetti nhỏ hơn (kích thước 3px)
            ctx.fill();
          }}
          initialVelocityY={5}
          tweenDuration={4000}
          colors={["#ff0", "#f00", "#0f0", "#00f", "#ff1493", "#ffa500"]}
        />
      </ConfettiWrapper>
      </AppWrapper>
    )
    }
    
    <audio
      ref={audioRef}
      loop
      src={require("./assets/ssstik.io_1740698847111.mp3")}
    />
    {
      openModal ? (
        <Modal>
            <ModalContent>
              <button 
                onClick={() => {
                  setStartThird(false);
                  setStartSecond(false);
                  setOpenModal(false);
                }}>
                <IoClose size={32}/>
              </button>
                {
                  openModal ? (
                    <TypeAnimation
                        key={6}
                        sequence={[
                          `You have a letter`,
                          300,
                          () => setStartSecond(true),
                        ]}
                        wrapper="h2"
                        speed={140}
                        repeat={Infinity}
                        cursor={false}
                      />
                  ) : ""}
                  {
                  startSecond ? (
                    <TypeAnimation
                        key={4}
                        className='text-wrap'
                        style={{
                          whiteSpace: "pre-line"
                        }}
                        sequence={[
                          `Happy Birthday, YURI! 🙀🙀🙀 \n Hope your day is packed with laughter, surprises, and way too much cake \n(Because no one gives you cake🥺🥺🥺).\nThey say age is just a number, but in your case, that number is desperately trying to keep up with how young and awesome you look! 🤏🏻🤏🏻🤏🏻 \n Wishing you a year filled with joy, wild adventures, and all the good vibes you deserve 🤸🏻🤸🏻🤸🏻.\n Now go celebrate like the queen you are \n — Today’s all about YOU! 🎂🎁🎊`,
                          300,
                          () => setStartThird(true),
                        ]}
                        wrapper="p"
                        speed={150}
                        repeat={Infinity}
                        cursor={true}
                      />
                  ) : ""}
                    {
                      startThird ?  
                        <TypeAnimation
                            key={5}
                            sequence={[
                              `27/3/2025 - from CONG HOAN with 💖`,
                              2000,
                            ]}
                            wrapper="h3"
                            speed={150}
                            style={{ display: 'block' }}
                            repeat={Infinity}
                            cursor={false}
                        /> : ""
                    }
            </ModalContent>
        </Modal>
      ) : null
    }
    </Fragment>
  );
}

export default App;

const Noise = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100vw;
  height: 100vh;
  opacity: .35;
  pointer-events: none;
`;

const LoadingText = styled.div`
  font-size: 55px;
  margin-bottom: 15px;
`;

const ProgressWrapper = styled.div`
  display: flex;
  column-gap: 5px;
`

const LoadingContent = styled.div`
  text-align: center;
  margin: 35px;
`;

const Block = styled.span`
  background: url(${require("./assets/minecraft-154749_1280.webp")});
  background-size: cover;
  width: 40px;
  height: 44px;
`

const LoadingWrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(${require("./assets/bg.png")});
  width: 100vw;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  background: rgb(42 40 35 / 46%);
  backdrop-filter: blur(15px);
  padding: 55px 15px;
  max-width: 100vw;
  
  button {
    margin: auto;
    cursor: pointer;
    position: absolute;
    top: 15px;
    right: 15px;
    background: unset;
    border: unset;
  }
`

const ModalContent =styled(ScrollContainer)`
  background: url(${require("./assets/bg.png")});
  font-family: "Gluten", cursive;

  padding: 35px;
  overflow-y: auto;
  border-radius: 35px;
  width: 600px;
  max-width: calc(100vh - 30px) !important;
  position: relative;
  cursor: grab;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
  p {
    font-size: 26px !important;
    line-height: 55px !important;
  }
  h2 {
    text-align: center;
    font-size: 32px;
  }
  h3 {
    font-weight: 400;
    font-size: 16px;
    display: block !important;
    margin-bottom: 55px;
  }
  @media (max-width: 768px) {
    p {
      font-size: 18px !important;
      line-height: 40px !important;
    }
    h2 {
      text-align: center;
      font-size: 28px;
      margin-bottom: 32px;
    }
    h3 {
      font-weight: 400;
      font-size: 14px;
      display: block !important;
      margin-bottom: 55px;
    }
  }
`

const ConfettiWrapper = styled.div`
  pointer-events: none;
`;

const AppWrapper = styled.div`
  background: url(${require("./assets/bg.png")});
  min-height: 100vh;
  padding: 35px 0px;
  height:  ${props => props.openModal ? "100vh" : "auto"};
  overflow-y: ${props => props.openModal ? "hidden" : "auto"};
  overflow-x: hidden;
`;

const BirthDayContent = styled.div`
  text-align: center;
  pointer-events: all;
  p {
    margin-bottom: 25px;
    font-size: 32px;
    color: #ff99ff;
    text-shadow: -1px -1px 0 #fbfbfb, 1px -1px 0 #ffffff, -1px 1px 0 #ffffff, 1px 1px 0 #ffffff;
  }
  h3 {
    font-weight: 600;
    font-size: 80px;
    margin: 0px;
    color: #515db6;
    text-shadow: -1px -1px 0 #fbfbfb, 1px -1px 0 #ffffff, -1px 1px 0 #ffffff, 1px 1px 0 #ffffff;
    span {
      font-size: 60%;
    }
  }
  .click {
    width: 160px;
  }
`;

const Container = styled.div`
  max-width: 992px;
  margin: auto;
  position: relative;
`;


const UIAImage = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  top: 0;
  justify-content: center;
  .uia {
    width: 22%;
    img {
      width: 100%;
    }
  }
  .trang {
    width: 54%;
    text-align: center;
    display: block;
    img {
      max-height: 55vh;
      max-width: 100%;
      display: block;
      width: auto;
      margin: auto;
    }
  }
  .click {
    pointer-events: all;
    cursor: pointer;
  }
`;

const RainBowTop = styled.div`
  display: flex;
  bottom: 0px;
  width: 100%;
  pointer-events: none;
  align-items: center;
  column-gap: 25px;
  margin-right: 25px;
  .rainbow {
    height: auto;
    max-width: 100px;
    max-height: 80px;
    display: block;
    margin: auto;
  }
`

const RainBowBottom = styled.div`
  display: flex;
  top: 0px;
  width: 100%;
  column-gap: 25px;
  pointer-events: none;
  align-items: center;
  margin-right: 25px;

  .rainbow {
    flex: 1;
    width: 25%;
    height: auto;
    max-width: 100px;
    max-height: 80px;
    display: block;
    margin: auto;
  }
`

const ButtonBirthday = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  pointer-events: all;
  padding: 9px 35px;
  font-size: 22px;
  border: unset;
  background: unset;
  margin: auto;
  margin-top: 35px;
  font-family: inherit;
  text-decoration: underline;
  outline: none;
`

const MainContent = styled.div`
  position: relative;
  z-index: 2;
  padding: 75px 15px;
`